<template>
  <div class="indented">
    <form @submit.prevent="submitForm" ref="formHTML">
      <div class="form-horizontal">
        <h2>Delete Category</h2>
        <hr />
        {{ catname }}
        <div class="spacer"></div>
        <h5>Are you sure you want to delete this category? All subcategories, associated products and alternative products will be deleted!</h5>
        <div>
          <div class="form-group spaced">
            <router-link style="text-decoration: none; color:inherit;" :to="{ path: '/DeleteCat', query: { CategoryId: catid } }">
              <input type="submit" value="Delete" class="button btn btn-default" />
            </router-link>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  export default {
    name: 'Comp_DeleteCategory',
    props: ['catid','catname'],
    data() {
      return {

      }
    },
    methods: {

    }
  }</script>

<style scoped src="bootstrap/dist/css/bootstrap.min.css">

  /* install bootstrap first by typing 'npm install bootstrap' in command prompt */
</style>

<style scoped>


  .indented {
    margin: 20px;
    max-width: 550px;
  }

  .spacer {
    height: 15px;
    border: 0px solid black;
  }

  .spaced {
    margin-top: 10px;
  }

  .button {
    border: 1px solid gray;
  }
</style>




// WEBPACK FOOTER //
// src/Comp_DeleteCategory.vue